import DataStore from './DataStore';
import Utils from '../common/Utils';
import Hotkeyword from '../common/components/Hotkeyword';
import Friend from './components/Friend';
import Guild from './components/Guild';
import Membership from './components/Membership';
import Nshop from './components/Nshop';
import Nctv from './components/Nctv';
import Promotion from './components/Promotion';
import UserState from './components/UserState';
import UserIcafe from './components/UserIcafe';
import BannerDday from './components/BannerDday';
import ModalLayer from './components/ModalLayer';
import FullcoverLayer from './components/FullcoverLayer';
import PersonalSet from './components/PersonalSet';

/**
 * testApp의 시작점..
 * @category testApp
 * @memberof module:testApp
 * @param  {Object} _config={} 설정 옵션
 * @param  {Object} _config.apiDomain="" api Domain
 * @param  {Object} _config.apiBoardDomain="" api Board Domain
 * @example
 * var testApp = new nc.lineage2.sampleApp({
 *      apiDomain: 'https://api-lineage2.plaync.com',
 *      apiBoardDomain: "https://api-board-lineage2.plaync.com"
 * });
 */
class App {
	constructor(_config = {}) {
		this.store = new DataStore(_config);
		this.selector = '#container';

		// this.store.getData('config', {}, (d) => console.log( 'config---',  d ) );

		this.hotkeyword = new Hotkeyword(this.store.getData('Hotkeyword'), this.selector + ' .hotkeyword', 'bottom');

		this.friend = new Friend(this.store, this.selector + ' .friend');
		this.guild = new Guild(this.store, this.selector + ' .guild');
		this.membership = new Membership(this.store, this.selector + ' .membership');
		this.nshop = new Nshop(this.store, this.selector + ' .nshop');
		this.nctv = new Nctv(this.store, this.selector + ' .card-type-nctv');
		this.promotion = new Promotion( this.selector + ' .section-promotion');
		//this.userState = new UserState(this.store, this.selector + ' .layer-userstate');
		//this.userIcafe = new UserIcafe(this.store, this.selector + ' .layer-userstate');

		this.bannerDday = new BannerDday(this.store, '#smartbanner.dday-banner');
		this.modalLayer = new ModalLayer(this.store, this.selector + ' .modal-layer');
		this.fullcoverLayer = new FullcoverLayer(this.store, this.selector + ' .fullcover-layer');
    this.cardOrder(this.store.data.config.cardOrder.order);

    this.personalSet = new PersonalSet(this.store,  this.selector + ' .personal');
	}
	cardOrder(_order){
	  const cardCon = $('.section-card-con');
	  for(let i = _order.length-1; i >=0; i--){
      let currentEle = $(cardCon).find(`[data-title="${_order[i].id}"]`);
	    let firstEle = $('.section-card-con > section').first();
	    $(currentEle).insertBefore(firstEle);
    }
  }
}

Utils.namespace('nc.bns.main');
nc.bns.main = App;